import {ethers} from "ethers";

export const fetchTokenData = `query fetchTokenData($id: ID!){
    token(id: $id){
    name
    symbol
  }
}`;

export const getReasonForFailure = (status, reason) => {
    let reasonForFailure;
    if (status === 'fail' && reason === 'maxGas') {
        reasonForFailure = 'Max Gas is too low, try a minimum of 700,000';
    }
    if (status === 'fail' && reason === 'gwei') {
        reasonForFailure = 'Gwei is too low, make sure to use a minimum of 5 gwei.';
    }
    if (status === 'fail' && reason === 'funds') {
        reasonForFailure = 'You don\'t have enough funds to execute this snipe.';
    }
    if (status === 'fail' && reason === 'insufficient_tokens') {
        reasonForFailure = 'You don\'t have enough tokens to sell';
    }
    return reasonForFailure;
}

export const TOKEN_ABI = [
    {
        "constant": true,
        "inputs": [{"name": "", "type": "address"}],
        "name": "balanceOf",
        "outputs": [{"name": "", "type": "uint256"}],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs":
            [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "from",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "to",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "value",
                    "type": "uint256"
                }
            ],
        "name": "Transfer",
        "type": "event"
    },
    {
        "constant": true,
        "inputs": [],
        "name": "decimals",
        "outputs": [{"name": "", "type": "uint8"}],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [],
        "name": "name",
        "outputs": [{"name": "", "type": "string"}],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [],
        "name": "symbol",
        "outputs": [{"name": "", "type": "string"}],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [],
        "name": "totalSupply",
        "outputs": [{"name": "", "type": "uint256"}],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [],
        "name": "getOwner",
        "outputs": [{"internalType": "address", "name": "", "type": "address"}],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [],
        "name": "owner",
        "outputs": [{"internalType": "address", "name": "", "type": "address"}],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "_owner",
        "outputs": [{"internalType": "address", "name": "", "type": "address"}],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {"internalType": "address", "name": "spender", "type": "address"},
            {"internalType": "uint256", "name": "amount", "type": "uint256"}
        ],
        "name": "approve",
        "outputs": [
            {"internalType": "bool", "name": "", "type": "bool"}
        ],
        "stateMutability": "nonpayable", "type": "function"
    },
];

export const PANCAKE_ROUTER_V2_ABI = [
    {
        "inputs": [{"internalType": "uint256", "name": "amountIn", "type": "uint256"}, {
            "internalType": "address[]",
            "name": "path",
            "type": "address[]"
        }],
        "name": "getAmountsOut",
        "outputs": [{"internalType": "uint256[]", "name": "amounts", "type": "uint256[]"}],
        "stateMutability": "view",
        "type": "function"
    }
];

export const PANCAKE_FACTORY_V2_ABI = [
    {
        "constant": true,
        "inputs": [{"internalType": "address", "name": "", "type": "address"}, {
            "internalType": "address",
            "name": "",
            "type": "address"
        }],
        "name": "getPair",
        "outputs": [{"internalType": "address", "name": "", "type": "address"}],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    'function balanceOf(address owner) external view returns (uint)',
];

export const UNISWAP_ROUTERV2_ABI = [{
    "inputs": [{
        "internalType": "address",
        "name": "_factory",
        "type": "address"
    }, {"internalType": "address", "name": "_WETH", "type": "address"}],
    "stateMutability": "nonpayable",
    "type": "constructor"
}, {
    "inputs": [],
    "name": "WETH",
    "outputs": [{"internalType": "address", "name": "", "type": "address"}],
    "stateMutability": "view",
    "type": "function"
}, {
    "inputs": [{"internalType": "address", "name": "tokenA", "type": "address"}, {
        "internalType": "address",
        "name": "tokenB",
        "type": "address"
    }, {"internalType": "uint256", "name": "amountADesired", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "amountBDesired",
        "type": "uint256"
    }, {"internalType": "uint256", "name": "amountAMin", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "amountBMin",
        "type": "uint256"
    }, {"internalType": "address", "name": "to", "type": "address"}, {
        "internalType": "uint256",
        "name": "deadline",
        "type": "uint256"
    }],
    "name": "addLiquidity",
    "outputs": [{"internalType": "uint256", "name": "amountA", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "amountB",
        "type": "uint256"
    }, {"internalType": "uint256", "name": "liquidity", "type": "uint256"}],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "address", "name": "token", "type": "address"}, {
        "internalType": "uint256",
        "name": "amountTokenDesired",
        "type": "uint256"
    }, {"internalType": "uint256", "name": "amountTokenMin", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "amountETHMin",
        "type": "uint256"
    }, {"internalType": "address", "name": "to", "type": "address"}, {
        "internalType": "uint256",
        "name": "deadline",
        "type": "uint256"
    }],
    "name": "addLiquidityETH",
    "outputs": [{"internalType": "uint256", "name": "amountToken", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "amountETH",
        "type": "uint256"
    }, {"internalType": "uint256", "name": "liquidity", "type": "uint256"}],
    "stateMutability": "payable",
    "type": "function"
}, {
    "inputs": [],
    "name": "factory",
    "outputs": [{"internalType": "address", "name": "", "type": "address"}],
    "stateMutability": "view",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "amountOut", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "reserveIn",
        "type": "uint256"
    }, {"internalType": "uint256", "name": "reserveOut", "type": "uint256"}],
    "name": "getAmountIn",
    "outputs": [{"internalType": "uint256", "name": "amountIn", "type": "uint256"}],
    "stateMutability": "pure",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "amountIn", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "reserveIn",
        "type": "uint256"
    }, {"internalType": "uint256", "name": "reserveOut", "type": "uint256"}],
    "name": "getAmountOut",
    "outputs": [{"internalType": "uint256", "name": "amountOut", "type": "uint256"}],
    "stateMutability": "pure",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "amountOut", "type": "uint256"}, {
        "internalType": "address[]",
        "name": "path",
        "type": "address[]"
    }],
    "name": "getAmountsIn",
    "outputs": [{"internalType": "uint256[]", "name": "amounts", "type": "uint256[]"}],
    "stateMutability": "view",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "amountIn", "type": "uint256"}, {
        "internalType": "address[]",
        "name": "path",
        "type": "address[]"
    }],
    "name": "getAmountsOut",
    "outputs": [{"internalType": "uint256[]", "name": "amounts", "type": "uint256[]"}],
    "stateMutability": "view",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "amountA", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "reserveA",
        "type": "uint256"
    }, {"internalType": "uint256", "name": "reserveB", "type": "uint256"}],
    "name": "quote",
    "outputs": [{"internalType": "uint256", "name": "amountB", "type": "uint256"}],
    "stateMutability": "pure",
    "type": "function"
}, {
    "inputs": [{"internalType": "address", "name": "tokenA", "type": "address"}, {
        "internalType": "address",
        "name": "tokenB",
        "type": "address"
    }, {"internalType": "uint256", "name": "liquidity", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "amountAMin",
        "type": "uint256"
    }, {"internalType": "uint256", "name": "amountBMin", "type": "uint256"}, {
        "internalType": "address",
        "name": "to",
        "type": "address"
    }, {"internalType": "uint256", "name": "deadline", "type": "uint256"}],
    "name": "removeLiquidity",
    "outputs": [{"internalType": "uint256", "name": "amountA", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "amountB",
        "type": "uint256"
    }],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "address", "name": "token", "type": "address"}, {
        "internalType": "uint256",
        "name": "liquidity",
        "type": "uint256"
    }, {"internalType": "uint256", "name": "amountTokenMin", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "amountETHMin",
        "type": "uint256"
    }, {"internalType": "address", "name": "to", "type": "address"}, {
        "internalType": "uint256",
        "name": "deadline",
        "type": "uint256"
    }],
    "name": "removeLiquidityETH",
    "outputs": [{"internalType": "uint256", "name": "amountToken", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "amountETH",
        "type": "uint256"
    }],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "address", "name": "token", "type": "address"}, {
        "internalType": "uint256",
        "name": "liquidity",
        "type": "uint256"
    }, {"internalType": "uint256", "name": "amountTokenMin", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "amountETHMin",
        "type": "uint256"
    }, {"internalType": "address", "name": "to", "type": "address"}, {
        "internalType": "uint256",
        "name": "deadline",
        "type": "uint256"
    }],
    "name": "removeLiquidityETHSupportingFeeOnTransferTokens",
    "outputs": [{"internalType": "uint256", "name": "amountETH", "type": "uint256"}],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "address", "name": "token", "type": "address"}, {
        "internalType": "uint256",
        "name": "liquidity",
        "type": "uint256"
    }, {"internalType": "uint256", "name": "amountTokenMin", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "amountETHMin",
        "type": "uint256"
    }, {"internalType": "address", "name": "to", "type": "address"}, {
        "internalType": "uint256",
        "name": "deadline",
        "type": "uint256"
    }, {"internalType": "bool", "name": "approveMax", "type": "bool"}, {
        "internalType": "uint8",
        "name": "v",
        "type": "uint8"
    }, {"internalType": "bytes32", "name": "r", "type": "bytes32"}, {
        "internalType": "bytes32",
        "name": "s",
        "type": "bytes32"
    }],
    "name": "removeLiquidityETHWithPermit",
    "outputs": [{"internalType": "uint256", "name": "amountToken", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "amountETH",
        "type": "uint256"
    }],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "address", "name": "token", "type": "address"}, {
        "internalType": "uint256",
        "name": "liquidity",
        "type": "uint256"
    }, {"internalType": "uint256", "name": "amountTokenMin", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "amountETHMin",
        "type": "uint256"
    }, {"internalType": "address", "name": "to", "type": "address"}, {
        "internalType": "uint256",
        "name": "deadline",
        "type": "uint256"
    }, {"internalType": "bool", "name": "approveMax", "type": "bool"}, {
        "internalType": "uint8",
        "name": "v",
        "type": "uint8"
    }, {"internalType": "bytes32", "name": "r", "type": "bytes32"}, {
        "internalType": "bytes32",
        "name": "s",
        "type": "bytes32"
    }],
    "name": "removeLiquidityETHWithPermitSupportingFeeOnTransferTokens",
    "outputs": [{"internalType": "uint256", "name": "amountETH", "type": "uint256"}],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "address", "name": "tokenA", "type": "address"}, {
        "internalType": "address",
        "name": "tokenB",
        "type": "address"
    }, {"internalType": "uint256", "name": "liquidity", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "amountAMin",
        "type": "uint256"
    }, {"internalType": "uint256", "name": "amountBMin", "type": "uint256"}, {
        "internalType": "address",
        "name": "to",
        "type": "address"
    }, {"internalType": "uint256", "name": "deadline", "type": "uint256"}, {
        "internalType": "bool",
        "name": "approveMax",
        "type": "bool"
    }, {"internalType": "uint8", "name": "v", "type": "uint8"}, {
        "internalType": "bytes32",
        "name": "r",
        "type": "bytes32"
    }, {"internalType": "bytes32", "name": "s", "type": "bytes32"}],
    "name": "removeLiquidityWithPermit",
    "outputs": [{"internalType": "uint256", "name": "amountA", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "amountB",
        "type": "uint256"
    }],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "amountOut", "type": "uint256"}, {
        "internalType": "address[]",
        "name": "path",
        "type": "address[]"
    }, {"internalType": "address", "name": "to", "type": "address"}, {
        "internalType": "uint256",
        "name": "deadline",
        "type": "uint256"
    }],
    "name": "swapETHForExactTokens",
    "outputs": [{"internalType": "uint256[]", "name": "amounts", "type": "uint256[]"}],
    "stateMutability": "payable",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "amountOutMin", "type": "uint256"}, {
        "internalType": "address[]",
        "name": "path",
        "type": "address[]"
    }, {"internalType": "address", "name": "to", "type": "address"}, {
        "internalType": "uint256",
        "name": "deadline",
        "type": "uint256"
    }],
    "name": "swapExactETHForTokens",
    "outputs": [{"internalType": "uint256[]", "name": "amounts", "type": "uint256[]"}],
    "stateMutability": "payable",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "amountOutMin", "type": "uint256"}, {
        "internalType": "address[]",
        "name": "path",
        "type": "address[]"
    }, {"internalType": "address", "name": "to", "type": "address"}, {
        "internalType": "uint256",
        "name": "deadline",
        "type": "uint256"
    }],
    "name": "swapExactETHForTokensSupportingFeeOnTransferTokens",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "amountIn", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "amountOutMin",
        "type": "uint256"
    }, {"internalType": "address[]", "name": "path", "type": "address[]"}, {
        "internalType": "address",
        "name": "to",
        "type": "address"
    }, {"internalType": "uint256", "name": "deadline", "type": "uint256"}],
    "name": "swapExactTokensForETH",
    "outputs": [{"internalType": "uint256[]", "name": "amounts", "type": "uint256[]"}],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "amountIn", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "amountOutMin",
        "type": "uint256"
    }, {"internalType": "address[]", "name": "path", "type": "address[]"}, {
        "internalType": "address",
        "name": "to",
        "type": "address"
    }, {"internalType": "uint256", "name": "deadline", "type": "uint256"}],
    "name": "swapExactTokensForETHSupportingFeeOnTransferTokens",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "amountIn", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "amountOutMin",
        "type": "uint256"
    }, {"internalType": "address[]", "name": "path", "type": "address[]"}, {
        "internalType": "address",
        "name": "to",
        "type": "address"
    }, {"internalType": "uint256", "name": "deadline", "type": "uint256"}],
    "name": "swapExactTokensForTokens",
    "outputs": [{"internalType": "uint256[]", "name": "amounts", "type": "uint256[]"}],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "amountIn", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "amountOutMin",
        "type": "uint256"
    }, {"internalType": "address[]", "name": "path", "type": "address[]"}, {
        "internalType": "address",
        "name": "to",
        "type": "address"
    }, {"internalType": "uint256", "name": "deadline", "type": "uint256"}],
    "name": "swapExactTokensForTokensSupportingFeeOnTransferTokens",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "amountOut", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "amountInMax",
        "type": "uint256"
    }, {"internalType": "address[]", "name": "path", "type": "address[]"}, {
        "internalType": "address",
        "name": "to",
        "type": "address"
    }, {"internalType": "uint256", "name": "deadline", "type": "uint256"}],
    "name": "swapTokensForExactETH",
    "outputs": [{"internalType": "uint256[]", "name": "amounts", "type": "uint256[]"}],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "amountOut", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "amountInMax",
        "type": "uint256"
    }, {"internalType": "address[]", "name": "path", "type": "address[]"}, {
        "internalType": "address",
        "name": "to",
        "type": "address"
    }, {"internalType": "uint256", "name": "deadline", "type": "uint256"}],
    "name": "swapTokensForExactTokens",
    "outputs": [{"internalType": "uint256[]", "name": "amounts", "type": "uint256[]"}],
    "stateMutability": "nonpayable",
    "type": "function"
}, {"stateMutability": "payable", "type": "receive"}];
export const UNISWAP_FACTORYV2_ABI = [{
    "inputs": [{
        "internalType": "address",
        "name": "_feeToSetter",
        "type": "address"
    }], "payable": false, "stateMutability": "nonpayable", "type": "constructor"
}, {
    "anonymous": false,
    "inputs": [{"indexed": true, "internalType": "address", "name": "token0", "type": "address"}, {
        "indexed": true,
        "internalType": "address",
        "name": "token1",
        "type": "address"
    }, {"indexed": false, "internalType": "address", "name": "pair", "type": "address"}, {
        "indexed": false,
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
    }],
    "name": "PairCreated",
    "type": "event"
}, {
    "constant": true,
    "inputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "name": "allPairs",
    "outputs": [{"internalType": "address", "name": "", "type": "address"}],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
}, {
    "constant": true,
    "inputs": [],
    "name": "allPairsLength",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
}, {
    "constant": false,
    "inputs": [{"internalType": "address", "name": "tokenA", "type": "address"}, {
        "internalType": "address",
        "name": "tokenB",
        "type": "address"
    }],
    "name": "createPair",
    "outputs": [{"internalType": "address", "name": "pair", "type": "address"}],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "constant": true,
    "inputs": [],
    "name": "feeTo",
    "outputs": [{"internalType": "address", "name": "", "type": "address"}],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
}, {
    "constant": true,
    "inputs": [],
    "name": "feeToSetter",
    "outputs": [{"internalType": "address", "name": "", "type": "address"}],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
}, {
    "constant": true,
    "inputs": [{"internalType": "address", "name": "", "type": "address"}, {
        "internalType": "address",
        "name": "",
        "type": "address"
    }],
    "name": "getPair",
    "outputs": [{"internalType": "address", "name": "", "type": "address"}],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
}, {
    "constant": false,
    "inputs": [{"internalType": "address", "name": "_feeTo", "type": "address"}],
    "name": "setFeeTo",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "constant": false,
    "inputs": [{"internalType": "address", "name": "_feeToSetter", "type": "address"}],
    "name": "setFeeToSetter",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function"
}];

export const PANCAKE_ROUTER_V2 = '0x10ED43C718714eb63d5aA57B78B54704E256024E';
export const PANCAKE_FACTORY_V2 = '0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73';
export const UNISWAP_ROUTER_V2 = '0x7a250d5630b4cf539739df2c5dacb4c659f2488d';
export const UNISWAP_FACTORY_V2 = '0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f';
export const WBNB_ADDRESS = '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c';
export const WETH_ADDRESS = '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2';
export const BUSD_ADDRESS = '0xe9e7cea3dedca5984780bafc599bd69add087d56';
export const BUSD_ETH_ADDRESS = '0x4Fabb145d64652a948d72533023f6E7A623C7C53';
export const BURN_ADDRESS = '0x000000000000000000000000000000000000dead';
export const UNISWAP_PROVIDER_URL = 'https://nd-317-113-860.p2pify.com/e8f47d7ccf004d146f62e7e0e29fc8b8';
export const BINANCE_PROVIDER_URL = 'https://bsc-dataseed1.ninicoin.io/';
export const defaultProviderUrls = ['https://nd-317-113-860.p2pify.com/e8f47d7ccf004d146f62e7e0e29fc8b8', 'https://bsc-dataseed1.ninicoin.io/'];
export const uniswap = 'Uniswap V2';
export const bsc = 'Binance Smart Chain'

export const getProviderUrl = (chain) => {
    switch (chain) {
        case bsc:
            return BINANCE_PROVIDER_URL;
        case uniswap:
            return UNISWAP_PROVIDER_URL;
        default:
            return '';
    }
}

export const getTokenPathForBuyingByChain = (chain, tokenAddress) => {
    switch (chain) {
        case bsc:
            return [WBNB_ADDRESS, tokenAddress];
        case uniswap:
            return [WETH_ADDRESS, tokenAddress];
        default:
            return '';
    }
}

export const getTokenPathForSellingByChain = (chain, tokenAddress) => {
    switch (chain) {
        case bsc:
            return [tokenAddress, WBNB_ADDRESS];
        case uniswap:
            return [tokenAddress, WETH_ADDRESS];
        default:
            return '';
    }
}

export const provider = (chain) => {
    let provider = new ethers.providers.JsonRpcProvider(getProviderUrl(chain));
    return provider;
}